// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"multiple-select_dropdown__3nAy7","dropdown__scroll":"multiple-select_dropdown__scroll__1o9IM"};